var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m7.50049 3.5-3 3-3-3","stroke":"#1f2e5c","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.125"}));
}

Arrow.defaultProps = {"fill":"none","height":"10","viewBox":"0 0 9 10","width":"9"};

module.exports = Arrow;

Arrow.default = Arrow;
